import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IPayment } from '../services/model/get-trip-data.model';

const phoneRegex = /^\+[1-9](?:[ .-]?\d){7,14}$/;

export function isNullOrUndefined(obj): boolean {
    return obj === null || obj === undefined;
}

export function getVoucherCode(payment: IPayment): string {
  return (
    payment.DataBlob?.paymentAttributes?.find(
      (attr) => attr.Key.toLowerCase() === "vouchercode"
    )?.Value || ""
  );
}

/** Validates international phone syntax and the global 8–15 digit length range. */
export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    return phoneRegex.test(String(control.value)) ? null : { invalidPhone: true };
  };
}

export function formatInternationalPhoneNumber(value: string): string | null {
  if (!phoneRegex.test(value)) {
    return null;
  }

  const digits = value.replace(/\D/g, "");
  return `+${digits.replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
}

/**
 * Generate a GUID (UUID v4) without external dependencies.
 */
export function generateGuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
